import { FlagEnum } from '../../../models/flags'

export const FLAG_TYPE_IDS = {
    TASK: 1,
    NOTE: 2,
    CFB: 3,
} as const

export const getFlagTypeById = (typeId: number): FlagEnum => {
    switch (typeId) {
        case FLAG_TYPE_IDS.TASK:
            return FlagEnum.TASK
        case FLAG_TYPE_IDS.CFB:
            return FlagEnum.CFB
        default:
            return FlagEnum.NOTE
    }
}
